// src/pages/Consultas.js
import React, { useState } from 'react';
import { useConsultas } from '../hooks/useConsultas';

import TablaConsultas from '../components/consultas/TablaConsultas';
import ModalInformeMedico from '../components/expediente/ModalInformeMedico';
import NuevaConsulta from '../components/NuevaConsulta';
import PantallaCargaMedica from '../components/common/PantallaCargaMedica'; // 🚀 IMPORTAMOS EL LATIDO

export default function Consultas() {
    // 1. LÓGICA DE DOMINIO (Hook)
    const { consultas, loading, recargar } = useConsultas();

    // 2. ESTADOS DE UI (Modales)
    const [consultaParaInforme, setConsultaParaInforme] = useState(null);
    const [openNuevaConsulta, setOpenNuevaConsulta] = useState(false);

    // 🚀 EFECTO GUAU: Pantalla de carga clínica inicial
    if (loading && consultas.length === 0) {
        return (
            <div className="p-6 md:p-8 max-w-7xl mx-auto">
                <PantallaCargaMedica variante="consultas" />
            </div>
        );
    }

    // 3. ORQUESTACIÓN VISUAL
    return (
        // 🚀 ANIMACIÓN SUAVE DE ENTRADA
        <div className="p-6 md:p-8 space-y-6 max-w-7xl mx-auto" style={{ animation: 'fadeIn 1s ease-in-out forwards' }}>
            {/* Cabecera */}
            <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 mb-4">
                <div>
                    <h1 className="text-3xl font-black text-slate-900 tracking-tight">Registro Histórico</h1>
                    <p className="text-sm font-semibold text-slate-500 mt-1">Auditoría global de actos médicos y triajes</p>
                </div>
                <button
                    onClick={() => setOpenNuevaConsulta(true)}
                    className="px-6 py-3.5 bg-clinica-primary text-white font-bold text-sm rounded-2xl shadow-md hover:bg-clinica-primary-dark transition-all"
                >
                    + Agendar Cita
                </button>
            </div>

            {/* Vista Delegada */}
            <TablaConsultas
                consultas={consultas}
                loading={loading}
                onVerInforme={(consulta) => setConsultaParaInforme(consulta)}
            />

            {/* Capa de Modales */}
            {openNuevaConsulta && (
                <NuevaConsulta
                    open={openNuevaConsulta}
                    onClose={() => setOpenNuevaConsulta(false)}
                    onSuccess={recargar}
                />
            )}

            {consultaParaInforme && (
                <ModalInformeMedico
                    consulta={consultaParaInforme}
                    paciente={consultaParaInforme.paciente}
                    onClose={() => setConsultaParaInforme(null)}
                />
            )}
        </div>
    );
}